export const ARRAY_SEPARATOR = ',';
export const BOOLEAN_TRUE = '1';
export const BOOLEAN_FALSE = '0';
export const EMPTY_VALUE = '';

export interface Query {
  [name: string]: string;
}

export interface QueryValueEncoder<T> {
  (data: T): string;
}

//these are encoders. rename them all!
export const string: QueryValueEncoder<string> = i => i;
export const nullableString: QueryValueEncoder<string | null> = i => i === null ? EMPTY_VALUE : i;
export const boolean: QueryValueEncoder<boolean> = (i: boolean): string => (i ? BOOLEAN_TRUE : BOOLEAN_FALSE);
export const nullableBoolean: QueryValueEncoder<boolean | null> = (i: boolean | null): string => (
  i === null ? EMPTY_VALUE : (i ? BOOLEAN_TRUE : BOOLEAN_FALSE)
);
export const number: QueryValueEncoder<number> = (i: number) => i.toString();
export const nullableNumber: QueryValueEncoder<number | null> = (i: number | null): string =>
  i === null ? EMPTY_VALUE : i.toString();
export const date: QueryValueEncoder<Date> = (i: Date): string => number(Math.floor(i.getTime() / 1000));
export const nullableDate: QueryValueEncoder<Date | null> = (i: Date | null): string =>
  (i === null ? EMPTY_VALUE : date(i));
export const strings: QueryValueEncoder<string[]> = (i: string[]): string => i.join(ARRAY_SEPARATOR);
export const numbers: QueryValueEncoder<number[]> = (i: number[]): string => strings(i.map(number));
export const numericEnum = <T extends number>(i: T) => number(i);
export const stringEnum = <T extends string>(i: T) => string(i);
export const numericEnums = <T extends number>(i: T[]): string => numbers(i);
export const stringEnums = <T extends string>(i: T[]): string => strings(i);
export const sortEncoder = (field: string, direction: string) => (
  !field || !direction || direction === 'asc'
    ? ''
    : '-'
) + field;

export const stringify = (query: Query) => (new URLSearchParams(query)).toString();

export const setQuery = (query: Query) => (request: Request) => {
  const clonedRequest = request.clone();
  const url = new URL(clonedRequest.url);
  url.search = stringify(query);

  return new Request(url.toString(), clonedRequest);
};

export interface PaginatableQuery {
  page: number;
  perPage: number;
}

export interface SortableQuery {
  sort: string;
  dir: string;
}

export const encodePaginatableQuery = (query: PaginatableQuery): Query => ({
  page: number(query.page),
  perPage: number(query.perPage),
});

export const encodeSortableQuery = (query: SortableQuery): Query => ({
  sort: sortEncoder(query.sort, query.dir),
});

export const filesToFormData = (files: File[], field = 'files[]'): FormData => {
  const formData = new FormData();
  files.forEach(file => formData.append(field, file, file.name));

  return formData;
};

export const fileToFormData = (file: File, field = 'file'): FormData => filesToFormData([file], field);
